module.exports = __webpack_public_path__ + "img/76a75de.jpg";